// check if the user non-institution
(function () {
    if ($('.institution-info-wrapper').is(':empty')) {
        $('.UX3InstitutionBanner').addClass('non-institution');
    }
})();

// to be removed
